<!--核心绩效指标报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          :disabled="organizationCodeOrigin&&organizationCodeOrigin!=='A001'"
          v-decorator="['organizationCode']"
          :allow-clear="false"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="exportApi" ref="download" />
        <download-modal :apiFun="apiInvCorePerformanceReportExportDailyPlanDenominatorDetail" ref="dailyPlanDenominatorDetailDownload" />
        <a-button :loading="btnLoading" type="primary" v-if="$hasPermi(['inv:invCorePerformanceReport:export'])" @click="handleExport">导出</a-button>
        <a-button :loading="btnLoading" type="primary" v-if="$hasPermi(['inv:invCorePerformanceReport:export'])" @click="handleDailyPlanDenominatorDetailExport">导出日计划分母明细</a-button>
        <a-button :loading="btnLoading" type="primary" v-if="$hasPermi(['inv:invCorePerformanceReport:refresh'])" @click="handleRefresh">刷新</a-button>
        <refresh-modal ref="refreshModalRef" @refresh="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <a-tabs :default-active-key="currentTab" type="card" @change="tabOnchange">
        <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.tab"></a-tab-pane>
      </a-tabs>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" :rowKey="rowKey" :scroll="{ fixScreen: true, x: 1000 }">
          <template v-for="item in tipColumns" :slot="(item.column+'Title')">
            <div :key="item.column">
              <span class="marginRight">{{ item.title }}</span>
              <a-tooltip placement="top" :title="item.tip">
                <a-icon type="info-circle" />
              </a-tooltip>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import { mapState } from 'vuex'
import {
  apiGetInvCorePerformanceReportList,
  apiInvCorePerformanceReportExport,
  apiGetInvCorePerformanceReportListSummary,
  apiInvCorePerformanceReportExportSummary,
  apiInvCorePerformanceReportExportDailyPlanDenominatorDetail
} from '@/api/report/core-indicators-report'
import refreshModal from "./components/refresh-modal.vue"
import { tipColumns } from "./common"

export default {
  name: 'CoreIndicatorsReport',
  components: { DownloadModal, refreshModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    columns () {
      const firstColumns = [
        { title: '组织编码', dataIndex: 'organizationCode', align: 'center', width: 90, stickyFixed: 'left' },
        { title: '库存组织名称', dataIndex: 'organizationName', align: 'center', width: 150, stickyFixed: 'left' }
      ]
      const dailyDimensionColumns = [{ title: '日期', dataIndex: 'calculateDate', align: 'center', width: 100, stickyFixed: 'left' }]
      const stageColumns = [{ title: '日期', dataIndex: 'calculateDateStr', align: 'center', width: 120, stickyFixed: 'left' }]
      const lastColumns = [
        {
          // title: '日计划开工数',
          dataIndex: 'dailyPlanStartWorkQuantity',
          scopedSlots: { title: "dailyPlanStartWorkQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '准时开工数',
          dataIndex: 'onTimeStartWorkQuantity',
          scopedSlots: { title: "onTimeStartWorkQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '准时开工率',
          dataIndex: 'onTimeStartWorkRateStr',
          scopedSlots: { title: "onTimeStartWorkRateStrTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '及时开工数',
          dataIndex: 'timelyStartWorkQuantity',
          scopedSlots: { title: "timelyStartWorkQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '及时开工率',
          dataIndex: 'timelyStartWorkRateStr',
          scopedSlots: { title: "timelyStartWorkRateStrTitle" },
          align: 'center',
          width: 100
        },
        { title: '每日计划完工数（目标值）', dataIndex: 'dailyPlanCompleteQuantity', align: 'center', width: 100 },
        {
          // title: '当日实际完工数',
          dataIndex: 'currentTodayActualCompleteQuantity',
          scopedSlots: { title: "currentTodayActualCompleteQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '计划内完工数',
          dataIndex: 'planCompleteQuantity',
          scopedSlots: { title: "planCompleteQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '提前完工数',
          dataIndex: 'advanceCompleteQuantity',
          scopedSlots: { title: "advanceCompleteQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '延期完工数',
          dataIndex: 'delayCompleteQuantity',
          scopedSlots: { title: "delayCompleteQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '当日实际入库数',
          dataIndex: 'currentTodayActualReceiveQuantity',
          scopedSlots: { title: "currentTodayActualReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '计划内入库数',
          dataIndex: 'planReceiveQuantity',
          scopedSlots: { title: "planReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '计划内提前入库数',
          dataIndex: 'planAdvanceReceiveQuantity',
          scopedSlots: { title: "planAdvanceReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '提前入库数',
          dataIndex: 'advanceReceiveQuantity',
          scopedSlots: { title: "advanceReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '延期入库数',
          dataIndex: 'delayReceiveQuantity',
          scopedSlots: { title: "delayReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '日计划分母',
          dataIndex: 'dailyPlanDenominator',
          scopedSlots: { title: "dailyPlanDenominatorTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '日计划达成率',
          dataIndex: 'dailyPlanAchievementRateStr',
          scopedSlots: { title: "dailyPlanAchievementRateStrTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '一次达交需求数',
          dataIndex: 'deliveryRequireQuantity',
          scopedSlots: { title: "deliveryRequireQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '一次达交达成数',
          dataIndex: 'deliveryReceiveQuantity',
          scopedSlots: { title: "deliveryReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '一次达交率',
          dataIndex: 'deliveryRateStr',
          scopedSlots: { title: "deliveryRateStrTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '调整后考核达交需求数',
          dataIndex: 'adjustAssessmentRequireQuantity',
          scopedSlots: { title: "adjustAssessmentRequireQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '调整后考核达交达成数',
          dataIndex: 'adjustAssessmentReceiveQuantity',
          scopedSlots: { title: "adjustAssessmentReceiveQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '综合达交率',
          dataIndex: 'comprehensiveDeliveryRateStr',
          scopedSlots: { title: "comprehensiveDeliveryRateStrTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '日计划齐套数',
          dataIndex: 'dailyPlanKittingQuantity',
          scopedSlots: { title: "dailyPlanKittingQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '日计划齐套率',
          dataIndex: 'dailyPlanKittingRateStr',
          scopedSlots: { title: "dailyPlanKittingRateStrTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '日入库数',
          dataIndex: 'dailyInventoryQuantity',
          scopedSlots: { title: "dailyInventoryQuantityTitle" },
          align: 'center',
          width: 100
        },
        // { title: '日入库金额', dataIndex: 'dailyInventoryAmount', align: 'center', width: 90 },
        // { title: '日加工产值', dataIndex: 'dailyProcessingOutputValue', align: 'center', width: 90 },
        {
          // title: '日工单变更套数',
          dataIndex: 'dailyWorkOrderChangeQuantity',
          scopedSlots: { title: "dailyWorkOrderChangeQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '工单变更通过套数',
          dataIndex: 'dailyWorkOrderChangePassQuantity',
          scopedSlots: { title: "dailyWorkOrderChangePassQuantityTitle" },
          align: 'center',
          width: 100
        },
        {
          // title: '欠产数',
          dataIndex: 'shortageProductQuantity',
          scopedSlots: { title: "shortageProductQuantityTitle" },
          align: 'center',
          width: 100
        }
      ]
      return [
        ...firstColumns,
        ...(this.currentTab === 'dailyDimension' ? dailyDimensionColumns : stageColumns),
        ...lastColumns
      ]
    }
  },
  data() {
    return {
      tipColumns,
      currentTab: 'dailyDimension',
      btnLoading: false,
      rowKey: 'id',
      exportApi: apiInvCorePerformanceReportExport,
      apiInvCorePerformanceReportExportDailyPlanDenominatorDetail,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInvCorePerformanceReportList, false),
        pageCurrent: true
      },
      tabList: [ { key: "dailyDimension", tab: '日维度' }, { key: "stage", tab: '阶段' } ],
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        calculateDate: undefined,
        startCalculateDate: undefined,
        endCalculateDate: undefined
      },
      formList: [
        { label: '库存组织名称', decorator: ['organizationCode'], type: 'organizationCode' },
        {
          label: '查询日期',
          type: 'range',
          decorator: ['calculateDate'],
          disposeFormat: {
            startCalculateDate: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endCalculateDate: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ]
    }
  },
  mounted() {
    if(this.organizationCodeOrigin) {
      // 初始化拿左上角组织
      this.queryParams.organizationCode = this.organizationCodeOrigin
      this.$refs.refSearchForm.form.setFieldsValue({ organizationCode: this.queryParams.organizationCode })
    }
    this.onSearch()
  },
  methods: {
    tabOnchange(val) {
      this.currentTab = val
      if(val === 'dailyDimension') {
        this.rowKey = 'id'
        this.exportApi = apiInvCorePerformanceReportExport
        this.tableProps.requestApi = generateLsTableResData(apiGetInvCorePerformanceReportList, false)
      } else {
        this.rowKey = 'key_id'
        this.exportApi = apiInvCorePerformanceReportExportSummary
        this.tableProps.requestApi = generateLsTableResData(apiGetInvCorePerformanceReportListSummary, false)
      }
      this.handleOk(false)
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      if(this.organizationCodeOrigin && this.organizationCodeOrigin !== 'A001') {
        params.organizationCode = this.organizationCodeOrigin
      }
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: undefined,
        calculateDate: undefined,
        startCalculateDate: undefined,
        endCalculateDate: undefined
      }
      if(this.organizationCodeOrigin && this.organizationCodeOrigin !== 'A001') {
        this.queryParams.organizationCode = this.organizationCodeOrigin
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 导出日计划分母明细
    handleDailyPlanDenominatorDetailExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.dailyPlanDenominatorDetailDownload.openModal(params)
    },
    // 刷新
    handleRefresh() {
      this.$refs.refreshModalRef.show()
    }
  }
}
</script>

<style scoped lang="less">
.marginRight{
  margin-right: 8px;
}
</style>
